export default __webpack_public_path__ + "static/media/main_logo_black.8ed61311.svg";